import React, { FC, Fragment } from "react";
import { Popover, Transition } from "@headlessui/react";
import Checkbox from "shared/Checkbox/Checkbox";
import ButtonPrimary from "shared/Button/ButtonPrimary";

interface PropertyTypeFilterProps {
  filteredPropertyTypes: any[];
  selectedPropertyTypeIds: string[]; // ✅ Changed to array
  onPropertyTypeChange: (ids: string[]) => void; // ✅ Changed to array
  onApply: (close: () => void) => void;
}

const PropertyTypeFilter: FC<PropertyTypeFilterProps> = ({
  filteredPropertyTypes,
  selectedPropertyTypeIds,
  onPropertyTypeChange,
  onApply,
}) => {
  // ✅ Get display text for selected types
  const getSelectedTypesText = () => {
    if (!selectedPropertyTypeIds || selectedPropertyTypeIds.length === 0) {
      return "Type of property";
    }
    
    if (selectedPropertyTypeIds.length === filteredPropertyTypes.length) {
      return "All Types";
    }
    
    const selectedNames = filteredPropertyTypes
      .filter(item => selectedPropertyTypeIds.includes(String(item.id)))
      .map(item => item.name);
    
    if (selectedNames.length === 0) {
      return "Type of property";
    }
    
    if (selectedNames.length > 2) {
      return `${selectedNames.length} types`;
    }
    
    return selectedNames.join(", ");
  };

  

  const isFilterApplied = selectedPropertyTypeIds && selectedPropertyTypeIds.length > 0;

  return (
    <Popover className="relative">
      {({ open, close }) => (
        <>
          <Popover.Button
            className={`flex items-center justify-center px-4 py-2 text-sm rounded-full border focus:outline-none transition-all ${
              open ? "!border-primary-500" : ""
            } ${
              isFilterApplied
                ? "bg-[#f5694b] text-white border-[#f5694b]"
                : "border-neutral-300 dark:border-neutral-700 text-neutral-700 dark:text-neutral-200 hover:border-neutral-400 dark:hover:border-neutral-500 bg-white dark:bg-neutral-800"
            }`}
          >
            <span>{getSelectedTypesText()}</span>
            <i className="las la-angle-down ml-2"></i>
          </Popover.Button>

          <Transition
            as={Fragment}
            enter="transition ease-out duration-200"
            enterFrom="opacity-0 translate-y-1"
            enterTo="opacity-100 translate-y-0"
            leave="transition ease-in duration-150"
            leaveFrom="opacity-100 translate-y-0"
            leaveTo="opacity-0 translate-y-1"
          >
            <Popover.Panel className="absolute z-10 w-screen max-w-sm px-4 mt-3 left-0 sm:px-0 lg:max-w-md">
              <div className="overflow-hidden rounded-2xl shadow-xl bg-white dark:bg-neutral-900 border border-neutral-200 dark:border-neutral-700">
                <div className="relative flex flex-col px-5 py-6 space-y-5">
                  <div>
                    <Checkbox
                      name="property_type_ids"
                      label="All Types"
                      isChecked={!selectedPropertyTypeIds || selectedPropertyTypeIds.length === 0}
                      onChange={() => onPropertyTypeChange([])}
                    />
                  </div>
                  {filteredPropertyTypes.map((item: any) => (
                    <div key={item.id}>
                      <Checkbox
                        name="property_type_ids"
                        label={`${item.name} (${item.property_count || 0})`}
                        isChecked={selectedPropertyTypeIds?.includes(String(item.id)) || false}
                        onChange={(e) => {
                          const itemId = String(item.id);
                          let newPropertyTypeIds = [...(selectedPropertyTypeIds || [])];

                          if (e) {
                            // Add if not already included
                            if (!newPropertyTypeIds.includes(itemId)) {
                              newPropertyTypeIds.push(itemId);
                            }
                          } else {
                            // Remove if unchecked
                            newPropertyTypeIds = newPropertyTypeIds.filter(id => id !== itemId);
                          }

                          onPropertyTypeChange(newPropertyTypeIds);
                        }}
                      />
                    </div>
                  ))}
                </div>
                <div className="p-5 bg-neutral-50 dark:bg-neutral-900 dark:border-t dark:border-neutral-800 flex items-center justify-end">
                  <ButtonPrimary
                    onClick={() => onApply(close)}
                    sizeClass="px-4 py-2 sm:px-5"
                  >
                    Apply
                  </ButtonPrimary>
                </div>
              </div>
            </Popover.Panel>
          </Transition>
        </>
      )}
    </Popover>
  );
};

export default PropertyTypeFilter;